import styled from 'styled-components'

export const AttributeFieldBox = styled.div`
  .MaasProduct-MuiAutocomplete-root {
    background-color: #fff;
  }
`
export const FixErrorFieldSku = styled.div`
  p {
    top: 100%;
    bottom: inherit !important;
  }
  input {
    background-color: #fff;
  }
`
export const VideoContainer = styled.div`
  border-radius: 16px;
  border-width: 1px;
  border-color: #cecfd1;
  border-style: solid;
  overflow: hidden;
`

export const VideoIconBox = styled.div`
  background-color: #f7f7f7;
  font-size: 66px;
  color: #dadada;
`

export const ImageBox = styled.div`
  border-color: #cecfd1;
  border-radius: 4px;
  border-width: 1px;
  border-style: solid;
  height: 48px;
  width: 48px;
  overflow: hidden;
`

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`
